// extracted by mini-css-extract-plugin
export default {"stheader":"MenuST_stheader__SffIQ","stheader__nav":"MenuST_stheader__nav__LSd29"};